import { useGetGraphemePrevalence } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.prevalence";
import { useMemo } from "react";

export function usePrevalentPinyin(grapheme: string, pinyin: string): string | null;
export function usePrevalentPinyin<PinyinEntry>(
  grapheme: string,
  pinyinList: readonly PinyinEntry[],
): readonly PinyinEntry[];
export function usePrevalentPinyin<PinyinEntry>(
  grapheme: string,
  pinyinOrList: string | readonly PinyinEntry[],
): string | null | readonly PinyinEntry[] {
  const getGraphemePrevalence = useGetGraphemePrevalence();

  return useMemo(() => {
    // Any real-word character (common / uncommon / rare) shows its readings; only obscure
    // components (bare primitives, unlisted glyphs) have no prevalent pinyin.
    const { asCharacter } = getGraphemePrevalence(grapheme);
    if (asCharacter !== "obscure") {
      return pinyinOrList;
    }
    if (typeof pinyinOrList === "string") {
      return null;
    }
    return [] as readonly PinyinEntry[];
  }, [getGraphemePrevalence, grapheme, pinyinOrList]);
}
